import { RequestResponse } from "@api";
import { Box, Grid } from "@material-ui/core";
import React, { useCallback, useContext, useEffect } from "react";
import { UPDATE_CUSTOM_FILTER, UPDATE_FILTERS_DATA } from "..";
import { Data, DropDown } from "../dropdown";
import { TableContext } from "../table";
import { RowWrapper } from "../types";
import { Search } from "./search-filters";

const fillDropDown = (rows: RowWrapper<RequestResponse>[]) => {
  const dropDownData: Data[] = [];

  rows.forEach((v: RowWrapper<RequestResponse>) => {
    const dropDownRow: Data = {
      key: v.row.data.userEmail,
      value: v.row.data.userEmail,
    };
    if (!dropDownData.some((item) => item.value === dropDownRow.value)) {
      dropDownData.push(dropDownRow);
    }
  });

  return dropDownData;
};

const customFilter = (
  rowsWrappers: RowWrapper<RequestResponse>[],
  filterData: any
): RowWrapper<RequestResponse>[] => {
  return rowsWrappers.filter((wrapper) => {
    return !!filterData && !!filterData.userEmail
      ? wrapper.row.data.userEmail.toLowerCase() ===
          filterData.userEmail.toLowerCase()
      : true;
  });
};

export const MyTeamAccessToolbar: React.FC = () => {
  const { state, dispatch } = useContext(TableContext);
  const { rows } = state;

  useEffect(() => {
    dispatch({ type: UPDATE_CUSTOM_FILTER, customFilter });
  }, [dispatch]);

  const onSearchUpdate = useCallback(
    (term: string) =>
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { searchTerm: term },
      }),
    [dispatch]
  );

  const onSelectEmail = useCallback(
    (term: string) =>
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { userEmail: term },
      }),
    [dispatch]
  );

  return (
    <Box mt={2} mb={2}>
      <Grid container direction="row" spacing={2}>
        <Grid item container xs={12} justify="flex-end">
          <Grid item xs={2}>
            <DropDown data={fillDropDown(rows)} onChange={onSelectEmail} />
          </Grid>
          <Grid item xs={3}>
            <Search
              onSearchUpdate={onSearchUpdate}
              placeholder={"Search by Reference No"}
            ></Search>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
